import { useCallback, useEffect } from 'react'

export const useFormConfig = () => {
	const adjustFontSize = useCallback(() => {
		const spans = document.querySelectorAll(
			'#main-form .label-floating .control-label span:not(.required)',
		)
		spans.forEach((span) => {
			if (span instanceof HTMLSpanElement) {
				span.style.fontSize = '' // reset the fontSize to its default

				const grandparent = span.parentElement?.parentElement
				let fontSize = parseFloat(
					window.getComputedStyle(span).fontSize,
				)
				if (grandparent) {
					while (
						span.getBoundingClientRect().width + 30 >
							grandparent.getBoundingClientRect().width &&
						fontSize > 10
					) {
						span.style.fontSize = --fontSize + 'px'
						span.getBoundingClientRect()
					}
				}
			}
		})
	}, [])

	// Pushes a control's floating label down into the input by the height of its description-above block, so the label doesn't overlap that text. Set as a CSS variable rather than a fixed offset since the description can wrap to a different number of lines depending on viewport width.
	const adjustDescriptionAboveOffset = useCallback(() => {
		const descriptions = document.querySelectorAll(
			'#main-form .description-above',
		)
		descriptions.forEach((description) => {
			if (!(description instanceof HTMLElement)) return

			const formGroup = description.nextElementSibling
			if (!(formGroup instanceof HTMLElement)) return

			const { height } = description.getBoundingClientRect()
			const { marginBottom } = window.getComputedStyle(description)
			const offset = height + (parseFloat(marginBottom) || 0)

			formGroup.style.setProperty(
				'--description-above-offset',
				`${offset}px`,
			)
		})
	}, [])

	const adjustAll = useCallback(() => {
		adjustFontSize()
		adjustDescriptionAboveOffset()
	}, [adjustFontSize, adjustDescriptionAboveOffset])

	useEffect(() => {
		const observer = new MutationObserver(() => adjustAll())
		observer.observe(document.body, { childList: true, subtree: true })

		requestAnimationFrame(adjustAll) // Run once when loaded

		window.addEventListener('resize', adjustAll)

		return () => {
			observer.disconnect()
			window.removeEventListener('resize', adjustAll)
		}
	}, [adjustAll])
}
